export enum Partner {
    YDUQS = 'yduqs', 
    UNYLEYA = 'unyleya', 
    ANIMA ='anima-educacao', 
    LIGA = 'liga-educacional', 
    '9I' = '9i', 
    FMU = 'fmu', 
    COGNA = 'cogna', 
    UNIHORIZONTES = 'unihorizontes'
}

const partnerSlugToIdMap: {[key:string]:string} = {
    'yduqs':'2ee389d2-7e3e-4b80-b136-60fcd255452e', 
    'unyleya': '4d562250-6af9-4022-b853-431f99592529', 
    'anima-educacao': '96e02258-2a21-4dc0-b46a-b83b24665406', 
    'liga-educacional': 'e9a17824-6593-44e5-90b5-a6981ebb014f', 
    '9i': 'd360c8a0-4b14-4882-907e-dbb886950e62', 
    'fmu': '9fdace9c-990a-4acd-b3f6-842ca0daa8f4', 
    'cogna': 'a6e64851-90d0-4819-b77f-3faf68409b0e', 
    'unihorizontes': '9ddb9421-04a7-4e54-93ff-618ccf77b47f'
} 

export function getPartnerIdBySlug(slug: string): string | null {
    if (partnerSlugToIdMap.hasOwnProperty(slug)) {
        return partnerSlugToIdMap[slug];
    }
    return null;
}

function getIdToPartnerSlugMap(): {[key: string]: string} {
    const map: {[key: string]: string} = {};
    for (const [slug, id] of Object.entries(partnerSlugToIdMap)) {
      map[id] = slug;
    }
    return map;
  }

export function getPartnerEnumById(id: string): string | null {
    const idToSlugMap = getIdToPartnerSlugMap();
    return idToSlugMap.hasOwnProperty(id) ? idToSlugMap[id] : null;
}

export function hasPartners(partnerId: string, hiddenPartnerSlugs: Partner[]): boolean {
    const hiddenPartnerIds = hiddenPartnerSlugs.map(slug => getPartnerIdBySlug(slug));
    return hiddenPartnerIds.includes(partnerId);
}
